import { render, staticRenderFns } from "./SharedFiles.vue?vue&type=template&id=2c214a12&scoped=true"
import script from "./SharedFiles.vue?vue&type=script&lang=js"
export * from "./SharedFiles.vue?vue&type=script&lang=js"
import style0 from "./SharedFiles.vue?vue&type=style&index=0&id=2c214a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c214a12",
  null
  
)

export default component.exports